var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeakLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1937 16.6919L9.03508 24.4457H13.9875L13.6475 29.5013H0L15.5002 0.498718L14.3281 18.7821V18.8205L13.1937 16.6919ZM14.3283 18.7821L15.5004 0.498718L31 29.5013H13.6476L13.9877 24.4457H22.3804L16.8611 14.1071L14.3283 18.7821Z",
    fill: "#ffffff",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeakLogoSmall);
export default __webpack_public_path__ + "static/media/PeakLogoSmall.05a60945d0fd59240f9095ffa9f8728e.svg";
export { ForwardRef as ReactComponent };